import ASI from '../../assets/ASI.jpg';
import Hexfork from '../../assets/hexfork.jpg';
import iXperience from '../../assets/iXperience.jpg';
import SLO__Hacks23 from '../../assets/open__path.jpg';
import SLO__Hacks22 from '../../assets/desend.jpg';
import HackSC22 from '../../assets/hacksc22.jpg';
import TVSA__Internal from '../../assets/tvsa__club.jpg';
import UVSA_Tet from '../../assets/uvsa_tet.jpg';
import UVSA_Camp from '../../assets/uvsa__camp.jpg';
import Committee__Head from '../../assets/pcw_com_head.jpg';
import WOW from '../../assets/wow__leader.jpg';
import LAEP from '../../assets/LAEP.png';
import CSC309 from '../../assets/MyInventory.png'

/**
 * "https://github.com/Castro19/LAEP-GPT"
 * "https://github.com/Luke7787/ImmaculateInventors"
 * "https://www.asi.calpoly.edu/discover-asi/about-asi/"
 * "https://www.linkedin.com/company/hexfork/?originalSubdomain=uk"
 * 'https://www.ixperience.co/who-we-are'
 * 'https://devpost.com/software/open-path?ref_content=user-portfolio&ref_feature=in_progress'
 * 'https://devpost.com/software/desend'
 * 'https://devpost.com/software/twitch-chat-sentiment-analyzer'
 * 'https://tetfestival.org/about/'
 * 'https://uvsa.org/camp/'
 * 'https://www.instagram.com/polyculturalweekend/'
 * 'https://orientation.calpoly.edu/wow/home'
 * 
 */

export const projectsData = [
    {
        id: 1,
        image: LAEP,
        title: 'LAEP Research Assistant',
        company: 'Cal Poly Computer Science and Software Engineering Department',
        category: 'work',
        link: "/"
    },
    {
        id: 2,
        image: CSC309,
        title: 'My Inventory - Immaculate Inventors',
        company: 'Cal Poly Computer Science and Software Engineering Department',
        category: 'project',
        link: "/"
    },
    {
        id: 3,
        image: ASI,
        title: 'Memberships Services Assistant',
        company: 'Associated Students Inc.',
        category: 'work',
        link: "/"
    },
    {
        id: 4,
        image: Hexfork,
        title: 'Software Developer Intern',
        company: 'Hexfork',
        category: 'work',
        link: "/"
    },  
    {
        id: 5,
        image: iXperience,
        title: 'Software Engineer Intern',
        company: 'iXperience',
        category: 'work',
        link: "/"
    },
    {
        id: 6,
        image: SLO__Hacks23,
        title: 'OpenPath',
        company: 'SLO hacks 2023',
        category: 'project',
        link: "/"
    },
    {
        id: 7,
        image: SLO__Hacks22,
        title: 'Desend',
        company: 'SLO Hacks 2022',
        category: 'project',
        link: "/"
    },
    {
        id: 8,
        image: HackSC22,
        title: 'Twitch Chat Sentiment Analyzer',
        company: 'HackSC 2022',
        category: 'project',
        link: "/"
    },
    {
        id: 9,
        image: TVSA__Internal,
        title: 'Internal and External Vice President and Inter-Collegiate Council',
        company: 'Thai Vietnamese Student Association',
        category: 'volunteer',
        link:'/tvsa'
    },
    {
        id: 10,
        image: UVSA_Tet,
        title: 'Volunteers Committee Dispatch Staff - Tet Festival',
        company: 'Union of Vietnamese Student Association',
        category: 'volunteer',
        link: "/"
    },
    {
        id: 11,
        image: UVSA_Camp,
        title: 'Programming and Logistics Staff - Project LEAD Camp',
        company: 'Union of Vietnamese Student Association',
        category: 'volunteer',
        link: "/"
    },
    {
        id: 12,
        image: Committee__Head,
        title: 'PolyCultural Weekend Operations Committee Head',
        company: 'Cal Poly MultiCultural Center',
        category: 'volunteer',
        link: "/"
    },  
    {
        id: 13,
        image: WOW,
        title: 'Week of Welcome Orientation Leader',
        company: 'Cal Poly New & Transition Program',
        category: 'volunteer',
        link: "/"
    },
]


export const projectsNav = [
    {
        name: 'all',
    },
    {
        name: 'work'
    },
    {
        name: 'project'
    },
    {
        name:'volunteer'
    }
]